<div class="flex flex-col gap-4">
  <ion-icon
    name="close-circle-outline"
    class="text-5xl text-red-500 self-center"
  ></ion-icon>
  <h3 class="text-2xl font-semibold mb-1 text-center">
    Your page has been rejected
  </h3>
  <div class="flex flex-col gap-3">
    <p class=""><strong>Agent Note: </strong>{{ rejectionReason() }}</p>
    <p class="text-justify text-neutral-600 text-sm">
      Please note that you will need to update your page in order to go through
      the approval process again.
    </p>
    <p class="text-justify text-neutral-600 text-sm">
      Your page will remain hidden from search results as long as it is
      rejected.
    </p>
  </div>
  <app-button
    (click)="modalService.close(modalId()!)"
    [type]="'dark'"
    [outlined]="true"
    >Close</app-button
  >
</div>
